let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h05Zl")).then(() => parcelRequire('1pDeP'));